import { useEffect, useState } from 'react';
import { Icone } from '../../design/Icone';
import { listarProdutos } from '../../produtos';
import type { ProdutoComercial } from '../../produtos';

/**
 * NOVO LOTE — o caminho para o produto que AINDA NÃO tem lote no pré-vencido: busca qualquer
 * produto do catálogo (nome, código, EAN ou fabricante) e abre a gaveta do produto já no
 * formulário "Lançar novo lote". O lote em si é gravado pela mesma rota e regras de sempre.
 */
export function BuscaParaNovoLote({
  aoEscolher,
  aoFechar,
}: {
  aoEscolher: (productId: string) => void;
  aoFechar: () => void;
}) {
  const [busca, setBusca] = useState('');
  const [itens, setItens] = useState<readonly ProdutoComercial[] | null>(null);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    const termo = busca.trim();
    if (termo.length < 2) {
      setItens(null);
      return;
    }
    let vivo = true;
    setCarregando(true);
    const t = window.setTimeout(() => {
      void listarProdutos({ filtro: 'todos', busca: termo, grupo: '', pagina: 1 }).then((r) => {
        if (!vivo) return;
        setCarregando(false);
        setItens(r.ok ? r.dados.itens.slice(0, 12) : []);
      });
    }, 300);
    return () => {
      vivo = false;
      window.clearTimeout(t);
    };
  }, [busca]);

  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && aoFechar();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [aoFechar]);

  return (
    <div className="nl-veu" onClick={aoFechar}>
      <div
        className="nl-caixa"
        role="dialog"
        aria-label="Escolher o produto do novo lote"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="nl-topo">
          <div>
            <h2>Novo lote de pré-vencido</h2>
            <p>Escolha o produto — mesmo que ele ainda não tenha nenhum lote no programa.</p>
          </div>
          <button type="button" className="nl-fechar" aria-label="Fechar" onClick={aoFechar}>
            <Icone nome="x" tamanho={16} traco={1.8} />
          </button>
        </header>
        <label className="nl-busca">
          <Icone nome="search" tamanho={15} traco={1.7} />
          <input
            autoFocus
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            placeholder="Nome, código, EAN ou fabricante"
            aria-label="Buscar produto"
          />
        </label>
        <div className="nl-lista">
          {busca.trim().length < 2 ? (
            <p className="nl-dica">Digite pelo menos 2 letras ou o código de barras.</p>
          ) : carregando && !itens ? (
            <p className="nl-dica">Buscando…</p>
          ) : itens && itens.length === 0 ? (
            <p className="nl-dica">Nenhum produto encontrado com esse nome, código ou EAN.</p>
          ) : (
            (itens ?? []).map((p) => (
              <button key={p.id} type="button" className="nl-item" onClick={() => aoEscolher(p.id)}>
                <span className="nl-item-nome">
                  <strong>{p.descricao}</strong>
                  <span>{[p.codigo, p.ean, p.fabricante].filter(Boolean).join(' · ') || '—'}</span>
                </span>
                <span className="nl-item-acao">
                  Lançar lote
                  <Icone nome="chev-r" tamanho={13} traco={1.8} />
                </span>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
